// ==========================================
// BuddyModule — the shared module for the AI companion
// ==========================================
// Import this once (SharedModule already does) and two surfaces become available
// anywhere in the app:
//
//   <app-buddy-host>    the always-present companion: bubble/edge tab, panel,
//                       habitat sheet, drag/snap, resize, Alt+Space
//   <app-buddy-glance>  the 300x220 header popover (4b)
//
// Everything else is internal to the feature and intentionally not exported.
//
// State lives in root-provided services (BbState, BuddyState, BuddyChat,
// BuddyWorkflow, BuddyProgress), so both surfaces read the same BB, the same thread
// and the same XP without either owning the other.
// ==========================================

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BbMascotComponent } from './bb-mascot/bb-mascot.component';
import { BuddyBubbleComponent } from './buddy-bubble/buddy-bubble.component';
import { BuddyEdgeTabComponent } from './buddy-edge-tab/buddy-edge-tab.component';
import { BuddyGlanceComponent } from './buddy-glance/buddy-glance.component';
import { BuddyHabitatComponent } from './buddy-habitat/buddy-habitat.component';
import { BuddyHistoryComponent } from './buddy-history/buddy-history.component';
import { BuddyHostComponent } from './buddy-host/buddy-host.component';
import { BuddyPanelComponent } from './buddy-panel/buddy-panel.component';
import { BuddyRailComponent } from './buddy-rail/buddy-rail.component';
import { BuddyChatLogComponent } from './components/buddy-chat-log/buddy-chat-log.component';
import { BuddyChipRailComponent } from './components/buddy-chip-rail/buddy-chip-rail.component';
import { BuddyInputRowComponent } from './components/buddy-input-row/buddy-input-row.component';
import { BuddyTtsChipComponent } from './components/buddy-tts-chip/buddy-tts-chip.component';
import { BuddyWorkflowCardComponent } from './components/buddy-workflow-card/buddy-workflow-card.component';
import { BuddyWorkflowPaletteComponent } from './components/buddy-workflow-palette/buddy-workflow-palette.component';
import { BuddyMarkdownPipe } from './pipes/buddy-markdown.pipe';

@NgModule({
  declarations: [
    // Surfaces
    BuddyHostComponent,
    BuddyPanelComponent,
    BuddyRailComponent,
    BuddyHabitatComponent,
    BuddyHistoryComponent,
    BuddyBubbleComponent,
    BuddyEdgeTabComponent,
    BuddyGlanceComponent,
    // Parts
    BbMascotComponent,
    BuddyChatLogComponent,
    BuddyChipRailComponent,
    BuddyInputRowComponent,
    BuddyTtsChipComponent,
    BuddyWorkflowCardComponent,
    BuddyWorkflowPaletteComponent,
    // Pipes
    BuddyMarkdownPipe,
  ],
  imports: [CommonModule],
  exports: [BuddyHostComponent, BuddyGlanceComponent],
})
export class BuddyModule {}
